import xw from 'xwind';
import { Container, Section } from '../../components';
import { Title, Line, Contant } from './PrivacyPolicy.style';
import { renderPublishedDate } from '../../utils';

const PrivacyPolicy = ({ pageByHandle }) => {
  const { title, body, updatedAt } = pageByHandle ?? {};

  return (
    <Section css={xw`pt-11`}>
      <Container>
        <Title>{title}</Title>
        <Line />
        <div css={xw`flex justify-end text-gray-700 text-lg`}>
          Last Updated:&nbsp;{renderPublishedDate(updatedAt)}
        </div>
        <Contant dangerouslySetInnerHTML={{ __html: body }} />
      </Container>
    </Section>
  );
};

export default PrivacyPolicy;
